import React, { ReactNode } from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'

export const PanelContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 6px;
`
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  // plus gap of container = 28px
  margin-right: 22px;
`

const Title = styled.div`
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
  font-size: ${sys.typescale[12].size};
  font-weight: ${sys.fontWeight.regular};
  line-height: ${sys.typescale[12].lineHeight};

  min-width: fit-content;
  white-space: nowrap;
`
export const ThemedTitle = ({ children }: { children: ReactNode }) => {
  const theme = useDisplayTheme() as Theme
  return <Title mode={theme}>{children}</Title>
}

const Value = styled.div`
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.weak};
  font-size: ${sys.typescale[14].size};
  font-weight: ${sys.fontWeight.medium};
  line-height: ${sys.typescale[14].lineHeight};
`
export const ThemedValue = ({ children }: { children: ReactNode }) => {
  const theme = useDisplayTheme() as Theme
  return <Value mode={theme}>{children}</Value>
}

export { ThemedTitle as Title, ThemedValue as Value }
